import React from 'react'
import { Link } from 'react-router-dom'
import { useSEO } from '../hooks/useSEO'

export function NotFoundPage() {
  useSEO({
    title: 'Siden blev ikke fundet (404) - BoSteendahl.dk',
    description: 'Den side du leder efter findes desværre ikke på BoSteendahl.dk. Find vej tilbage til kropsterapi, coaching eller kontakt.',
  })

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 bg-[#FAF8F5]">
      <div className="max-w-xl w-full text-center bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-[#E5E0D8]">
        <span className="text-6xl sm:text-7xl font-serif font-bold text-[#7c875a] block mb-2">
          404
        </span>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#1b3a4b] mb-4">
          Siden blev ikke fundet
        </h1>
        <p className="text-sm sm:text-base text-[#64748B] leading-relaxed mb-8">
          Vi kunne desværre ikke finde den side, du ledte efter. Siden kan være flyttet, eller adressen kan være stavet forkert.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1b3a4b] hover:bg-[#132835] text-white px-6 py-3.5 rounded-full text-sm font-semibold transition shadow-sm"
          >
            <i className="fa-solid fa-house text-xs text-[#7c875a]" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-[#E5E0D8] hover:border-[#1b3a4b] text-[#1b3a4b] px-6 py-3.5 rounded-full text-sm font-medium transition hover:bg-[#FAF8F5]"
          >
            <span>Kontakt Bo</span>
          </Link>
        </div>

        <div className="pt-8 border-t border-[#F1EBE4]">
          <span className="text-xs font-semibold text-[#64748B] uppercase tracking-wider block mb-3">
            Hurtige genveje
          </span>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs font-medium text-[#1b3a4b]">
            <Link to="/kropsterapi" className="hover:text-[#7c875a] underline">
              Kropsterapi
            </Link>
            <Link to="/coaching" className="hover:text-[#7c875a] underline">
              Coaching
            </Link>
            <Link to="/hypnoterapi" className="hover:text-[#7c875a] underline">
              Hypnoterapi
            </Link>
            <Link to="/forloeb" className="hover:text-[#7c875a] underline">
              Forløb
            </Link>
            <Link to="/om-bo" className="hover:text-[#7c875a] underline">
              Om Bo
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
